import React, { useEffect, useState } from 'react'

const Upcoming: React.FC = () => {
    const [shouldHide, setShouldHide] = useState(false)

    useEffect(() => {
        const currentDate = new Date()
        console.log(currentDate)
        const mayFirst = new Date(currentDate.getFullYear(), 4, 1) // Months are 0-indexed, so 4 is May
        console.log(currentDate >= mayFirst)
        if (currentDate >= mayFirst) {
            setShouldHide(true)
        }
    }, [])

    const events: any = [
        {
            title: `Game Night`,
            location: 'Location TBD',
            date: 'Friday, February 21st, 2026 | 2pm-6pm',
            image: './img/events/gamenight.jpg',
            link: 'http://shop-thehouse.square.site/events',
            description: `Join us for an evening of board games, card games, and friendly competition! Bring your favorite games or try something new. All skill levels welcome!`,
        },
        {
            title: `Game Night at Luminarium PLAY`,
            location: 'Luminarium PLAY, Omaha, Nebraska',
            date: 'Thursday, March 20th, 2026 | 6pm-8pm',
            image: './img/events/gamenight.jpg',
            link: 'http://shop-thehouse.square.site/events',
            description: `Experience game night at the amazing Luminarium PLAY! Explore their incredible space while enjoying board games, tabletop games, and great company. Food and drinks available.`,
        },
        {
            title: `Old School Game Night`,
            location: 'The Union for Contemporary Art, 2423 N 24th St, Omaha, NE 68110',
            date: 'Friday, April 18th, 2026 | 7pm-10pm',
            image: './img/events/gamenight.jpg',
            link: 'http://shop-thehouse.square.site/events',
            description: `Get nostalgic at our Old School Game Night! Break out the classics - Monopoly, Uno, Dominoes, Spades, and more! Bring your favorite vintage games from childhood or discover the timeless games that have brought people together for generations.`,
        },
    ]

    return (
        <section className="page-section" id="upcoming">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className="text-center">
                            <h2 className="section-heading text-uppercase">Signature Events</h2>

                            <div className="row justify-content-center">
                                {events.length > 0 ? (
                                    events.map((event: any, idx: number) => (
                                        <div className="col-4" key={idx}>
                                            <div className="card">
                                                <img src={event.image} className="card-img-top" alt="..." />
                                                <div className="card-body">
                                                    <h5 className="card-title">{event.title}</h5>
                                                    <p className="card-text" style={{ overflow: 'visible', height: '100%', display: 'block' }}>
                                                        {event.description}
                                                    </p>
                                                    <p className="card-text">{event.date}</p>
                                                    <a href={event.link} className="btn btn-primary" style={{ background: '#000' }}>
                                                        RSVP
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <h3>Check back soon for more events!</h3>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Upcoming
